var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6619_34040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 6.5C11 7.29565 10.6839 8.05871 10.1213 8.62132C9.55871 9.18393 8.79565 9.5 8 9.5C7.20435 9.5 6.44129 9.18393 5.87868 8.62132C5.31607 8.05871 5 7.29565 5 6.5C5 5.70435 5.31607 4.94129 5.87868 4.37868C6.44129 3.81607 7.20435 3.5 8 3.5C8.79565 3.5 9.55871 3.81607 10.1213 4.37868C10.6839 4.94129 11 5.70435 11 6.5Z",
    fill: "#183059"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.5C0 6.37827 0.842855 4.34344 2.34315 2.84315C3.84344 1.34285 5.87827 0.5 8 0.5C10.1217 0.5 12.1566 1.34285 13.6569 2.84315C15.1571 4.34344 16 6.37827 16 8.5C16 10.6217 15.1571 12.6566 13.6569 14.1569C12.1566 15.6571 10.1217 16.5 8 16.5C5.87827 16.5 3.84344 15.6571 2.34315 14.1569C0.842855 12.6566 0 10.6217 0 8.5ZM8 1.5C6.68178 1.50007 5.39037 1.87236 4.2744 2.57403C3.15844 3.27569 2.26328 4.27821 1.69196 5.46619C1.12065 6.65418 0.896386 7.97934 1.045 9.28916C1.19361 10.599 1.70905 11.8402 2.532 12.87C3.242 11.726 4.805 10.5 8 10.5C11.195 10.5 12.757 11.725 13.468 12.87C14.2909 11.8402 14.8064 10.599 14.955 9.28916C15.1036 7.97934 14.8794 6.65418 14.308 5.46619C13.7367 4.27821 12.8416 3.27569 11.7256 2.57403C10.6096 1.87236 9.31822 1.50007 8 1.5Z",
    fill: "#183059"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6619_34040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.dc156014fcd448aa964e50e9db4d534a.svg";
export { ForwardRef as ReactComponent };